export default {
  search: {
    title: "Search",
    trending: "Trending",
    noResults: 'No results found for "{{query}}"',
    sections: {
      games: "Games",
      props: "Props",
      position: "Position",
      trending: "Trending",
      players: "Players",
      teams: "Teams",
      markets: "Markets",
      matchups: "Matchups",
    },
    empty: {
      noResults: 'No results found for "{{query}}"',
      noGamesAvailable: "No games available",
      checkBackLater: "Please check back later",
    },
    actions: {
      searchByGame: "Search by game",
      viewMatchups: "View matchups",
      searchByProp: "Search by prop",
      searchByPosition: "Search by position",
    },
    discovery: {
      Hits: "Hits",
      "Total Bases": "Total Bases",
      RBI: "RBI",
      Strikeouts: "Strikeouts",
      Results: "Results",
      Totals: "Totals",
      "Goals & Assists": "Goals & Assists",
      "Shots on Goal": "Shots on Goal",
      Points: "Points",
      "Powerplay Points": "Powerplay Points",
    },
    positions: {
      Forwards: "Forwards",
      Midfielders: "Midfielders",
      Defense: "Defense",
      Guards: "Guards",
      Centers: "Centers",
      QB: "QB",
      RB: "RB",
      WR: "WR",
      TE: "TE",
      K: "K",
      Wingers: "Wingers",
      Goalies: "Goalies",
      Pitchers: "Pitchers",
      Hitters: "Hitters",
    },
  },
};